<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Cấu hình kiểu thông báo</h2>
      </div>
    </el-row>
    <el-row type="flex" class="row-bg" :gutter="24">
      <el-col :span="12">
        <h3>Danh sách</h3>
      </el-col>
      <el-col :span="10">
        <div style="float: left">
          <h3 v-if="updateTargetId">Sửa kiểu thông báo</h3>
          <h3 v-else>Thêm mới kiểu thông báo</h3>
        </div>
        <div type="primary" style="float: right">Thêm mới / Sửa</div>
      </el-col>
    </el-row>
    <el-row>
      <div class="model-body">
        <el-row type="flex" class="row-bg" :gutter="24">
          <el-col :span="12">
            <el-row>
              <div class="model-pagination">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="table.pagination.per_page"
                  :pager-count="table.pagination.count"
                  :current-page="table.pagination.current_page"
                  :total="table.pagination.total"
                  @current-change="changeCurrentPage">
                </el-pagination>
                <div style="padding-left: 5px">
                  Hiển thị tới Kiểu thông báo số <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> Kiểu thông báo
                </div>
              </div>
            </el-row>
            <div class="model-table">
              <el-table v-loading="loading" :data="table.database" style="width: 100%">
                <el-table-column type="index" indexlabel="No." width="50">
                </el-table-column>
                <el-table-column prop="name" label="Tên" width="180">
                </el-table-column>
                <el-table-column prop="status" label="Trạng thái" width="80">
                  <template slot-scope="scope">
                    <el-switch
                      v-model="scope.row.status"
                      active-color="#13ce66"
                      inactive-color="#7f8c8d"
                      @change="changeStatus(scope.row)">
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column prop="created_at" label="Ngày tạo" width="100">
                </el-table-column>
                <el-table-column label="Hành động" width="180">
                  <template slot-scope="scope">
                    <el-row>
                      <el-button @click="updateModel(scope.row)" size="small" type="primary" :edit-id="scope.row.id" icon="el-icon-edit"
                        circle plain></el-button>
                      <el-button @click="confirmDeleteModel(scope.row)" size="small" type="danger" :delete-id="scope.row.id" icon="el-icon-delete"
                        circle plain></el-button>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple-light">
              <el-form :model="form" :rules="rules" ref="createModel" @submit.native.prevent>
                <el-form-item prop="name" label="Tên kiểu thông báo" class="form-item">
                  <el-input v-model="form.name" placeholder="Tên kiểu thông báo" class="input-seach" clearable></el-input>
                </el-form-item>
                <el-form-item prop="status" label="Trạng thái">
                  <el-switch v-model="form.status" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitForm('createModel')" size="small" plain :disable="!canSubmit" :loading="!canSubmit">
                    <i class="fa fa-save"></i> Lưu lại
                  </el-button>
                  <el-button type="warning" @click="reloadForm()" size="small" plain :disable="!canSubmit" :loading="!canSubmit">
                    <i class="fas fa-redo"></i> Hoàn tác
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>

      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'CategoryNotis',
  metaInfo () {
    return {
      title: 'Cấu hình kiểu thông báo'
    }
  },
  data() {
    return {
      canSubmit: true,
      loading: false,
      updateTargetId: 0,
      form: {
        name: '',
        status: true,
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên kiểu thông báo' },
          { min: 2, max: 191, message: 'Tên bài học có chiều dài từ 2 tới 191 kí tự' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'category-notis', text: 'Cấu hình kiểu thông báo' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('category-notis', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })

    },
    storeModel () {
      this.canSubmit = false

      if (this.updateTargetId && this.updateTargetId != 0) {
        axios.put('category-notis/' + this.updateTargetId, this.form).then(response => {
          this.canSubmit = true
          switch (response.code) {
            case 200:
              this.$notify({
                title: 'Thành công',
                message: 'Cập nhật Kiểu thông báo thành công',
                type: 'success'
              })
              this.form.name = ''
              this.fetchDatabaseModel()
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      }
      else {
        axios.post('category-notis', this.form).then(response => {
          this.canSubmit = true
          switch (response.code) {
            case 200:
              this.$notify({
                title: 'Thành công',
                message: 'Thêm kiểu thông báo thành công',
                type: 'success'
              })

              this.form.name = ''
              this.fetchDatabaseModel()
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      }
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.put('category-notis/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },
    updateModel (model) {
      this.updateTargetId = model.id
      this.form = model
    },
    reloadForm () {
      this.updateTargetId = 0
      this.form.name = ''
      this.form.status = true
      this.fetchDatabaseModel()
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('category-notis/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/noti-form/NotiType.vue